import {
  beginFeatureFlagFetch,
  endFeatureFlagFetch,
  updateFeatureFlagValue,
} from 'actions/featureFlag';
import * as featureFlagUtil from 'utilities/featureFlag';
import * as sentry from 'utilities/sentry';

export function getFeatureFlagCreator(flag, extraProperties) {
  return async (dispatch, getState) => {
    try {
      if (!flag || flag === '') {
        return;
      }

      const currentValue = getState().feature_flags[flag] || {};

      // in case we have already retrieved a flag or are retreiving
      // donot start again
      if (currentValue.fetched || currentValue.fetching) {
        return;
      }

      dispatch(beginFeatureFlagFetch(flag));

      const flagValue = await featureFlagUtil.getFlagValueForUser(
        flag,
        false,
        extraProperties
      );

      dispatch(updateFeatureFlagValue(flag, flagValue));

      return flagValue;
    } catch (err) {
      dispatch(endFeatureFlagFetch(flag));
      sentry.logException(err, 'error while fetching feature flag');
    }
  };
}
